import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import ToastModal from "views/components/ToastModal";
import CustomSelectNew from "../../../components/UpdateUi/CustomeSelect";
import { toCamelCase } from "utils/Utils";
import { glHeadTableColumns } from "assets/properties/properties";
import { glHeadMasterData } from "assets/properties/properties";
import { sortByString } from "utils/Utils";
import { removeUnderscores } from "utils/Utils";

const GlHeadMaster = ({ classes }) => {
  const navigate = useNavigate();
  const [rawData, setRawData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");

  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [productTypeList, setProductTypeList] = useState([]);
  const [productType, setProductType] = useState("");
  const [editedDescription, setEditedDescription] = useState("");

  const handlecreatehierarchySubmit = () => {
    navigate(glHeadMasterData?.createLink, {
      state: {
        productTypeList: productTypeList,
        findData: rawData,
        selectedProductType: productType,
      },
    });
  };

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
    getProductTypeListData();
  }, []);

  const getProductTypeListData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_PRODUCT_TYPE,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      if (Array.isArray(result?.data) && result.data.length > 0) {
      // Move "Gold Loan" to the front
      const goldLoan = result.data.find(item => item.name === glHeadMasterData?.goldLoan);
      const others = result.data.filter(item => item.name !== glHeadMasterData?.goldLoan);
      const reorderedList = goldLoan ? [goldLoan, ...others] : result.data;

      setProductTypeList(reorderedList);
      setProductType(reorderedList[0]?.code);
    }
    }
  };
  useEffect(() => {
    console.log(productType,"fdlajfsjdjf")
    if (productType) {
      getData();
    }
  }, [productType]);
  const getData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GL_HEAD_FIND + `${productType}`,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
    if (result?.data?.glHeads?.length > 0) {
      parseIndicatorData(result?.data?.glHeads);
      setRawData(result?.data);
    }else{
      setSelectedTableData([]);
      setRawData([]);
    }
    }
  };

  // parseindicatordata function
  const parseIndicatorData = (data,updatedCode) => {
    const sortedArray = sortByString(data, 'code', true);
    let reportData = [];
    data.forEach((GLHead) => {
      const isEditing = updatedCode === GLHead.code;
      const row = {
        name: removeUnderscores(GLHead.name),
        code: GLHead.code,
        description: GLHead.description,
        action: getIcons(GLHead),
      };
      reportData.push(row);
    });

    setSelectedTableData(reportData);
  };

  const getIcons = (rowData) => {
    return (
      <>
        <IconButton
          aria-label={glHeadMasterData?.arialLabel}
          onClick={() => {navigate(glHeadMasterData?.editLink, {
            state: {
              rowData: rowData,
            },
          });}}
        >
          <EditIcon />
        </IconButton>
      </>
    );
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label={glHeadMasterData?.label}
          button1={glHeadMasterData?.buttonLabel}
          button1click={handlecreatehierarchySubmit}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <GridItem xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomSelectNew
            label="Product Type*"
            id="product_type"
            value={productType}
            setState={setProductType}
            data={productTypeList}
            type="newSchemeCharge"
          />
        </GridItem>
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <TableContainer component={Paper} elevation={0}>
          <ColumnGroupingTable
            columns={glHeadTableColumns}
            rows={selectedTableData}
          />
        </TableContainer>
      </GridItem>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </GridContainer>
  );
};

export default GlHeadMaster;
